export default [
    {
        path: '/mismatch-monitor',
        name: 'mismatch-monitor',
        component: () => import('@/views/mismatch-monitor/index.vue')
    }
];
